import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Badge, Skeleton, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';

import { useGetReferenceQuery } from 'app/services/edpApiV1/references';

import { dataObjectForReferencesTable, dataObjectForTableReferences, sortingDate } from 'shared/helpers/utils';

import { useIndicators } from 'features/indicators';
import { TPreparedReferencesData, TPreparedReferencesUserDataInfo } from 'shared/types/reference.types';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import { useAppSelector } from 'app/store';
import ReferencesComments from '../referencesComments';
import ReferencesUserForm from '../referencesUserForm';
import style from './index.module.scss';

/**
 * @page References user subordinates
 */

const columns: ColumnsType<TPreparedReferencesUserDataInfo> = [
  {
    title: '№',
    dataIndex: 'id',
    key: 'key',
    width: 120,
  },
  {
    title: 'Дата',
    dataIndex: 'created',
    key: 'created',
    sorter: (a, b) => sortingDate(a.created, b.created),
  },
  {
    title: 'Вид справки',
    dataIndex: 'refTypeName',
    key: 'refTypeName',
  },
  {
    title: 'Период',
    dataIndex: 'year',
    key: 'year',
  },
  {
    title: 'ФИО',
    dataIndex: 'fio',
    key: 'fio',
  },
  {
    title: 'Получение',
    dataIndex: 'gettingMethod',
    key: 'gettingMethod',
  },
  {
    title: 'Статус',
    dataIndex: 'status',
    key: 'status',
    render: status => (
      <span>
        <Badge status={status.type} />
        {status.text}
      </span>
    ),
  },
];

const ReferencesUserSubordinates = () => {
  const [dataReferences, setDataReferences] = useState<TPreparedReferencesData[]>();
  const [commentsData, setCommentsData] = useState<string | null>();
  const dataTable = useRef<TPreparedReferencesUserDataInfo[]>();
  const { id } = useParams();
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const {
    data: reference,
    isLoading,
    isSuccess,
    isFetching,
  } = useGetReferenceQuery({ requestId: Number(id), allAvailableOrganizations });

  useEffect(() => {
    if (reference) {
      const dataReferences = dataObjectForTableReferences(reference);
      const dataForTable = dataObjectForReferencesTable(reference);
      dataTable.current = dataForTable;
      setDataReferences(dataReferences);
    }
  }, [reference]);

  useEffect(() => {
    if (dataReferences) {
      setCommentsData(dataReferences[0]?.comment);
    }
  }, [dataReferences]);

  useIndicators(isSuccess, isFetching);

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <div className={style.wrap}>
          <Table scroll={{ x: true }} dataSource={dataTable.current} columns={columns} pagination={false} bordered />
          {dataReferences && <ReferencesUserForm dataReferences={dataReferences} />}
        </div>
      )}

      {commentsData && <ReferencesComments commentsData={commentsData} />}

      {/* <ReferencesCommentsSend id={id} comment={commentsData} /> */}
    </>
  );
};

export default ReferencesUserSubordinates;
